import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { http, Me } from "./api";

type Ctx = { token: string; me: Me | null; error: string };
const C = createContext<Ctx>({ token: "", me: null, error: "" });
export const useSession = () => useContext(C);

export function SessionProvider({ children }: { children: ReactNode }) {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [state, setState] = useState<Ctx>({ token: "", me: null, error: "" });
  useEffect(() => {
    if (!isAuthenticated) return;
    let stop = false;
    const refresh = async () => {
      try {
        const t = (await getAccessTokenSilently()) ?? "";
        const me = await http.get<Me>(t, "/me");
        if (!stop) setState({ token: t, me: me.ok ? me.result : null, error: me.ok ? "" : me.error });
      } catch (e) {
        if (!stop) setState((s) => ({ ...s, error: (e as Error).message }));
      }
    };
    refresh();
    const iv = setInterval(refresh, 10 * 60_000);
    return () => {
      stop = true;
      clearInterval(iv);
    };
  }, [isAuthenticated, getAccessTokenSilently]);
  return <C.Provider value={state}>{children}</C.Provider>;
}
